/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  TakeoffProfileType_Enum,
  takeoffProfileType_EnumFromJSON,
  takeoffProfileType_EnumToJSON,
} from "../../../../gen/planner/takeoff_profile_type";

export const protobufPackage = "skills";

export interface RequestTakeoffProfileActionArgs {
  /** [s] */
  timeoutS: number;
  profileType: TakeoffProfileType_Enum;
}

export interface RequestTakeoffProfileResultData {
}

export interface RequestTakeoffProfileActionStateData {
}

function createBaseRequestTakeoffProfileActionArgs(): RequestTakeoffProfileActionArgs {
  return { timeoutS: 0, profileType: 0 };
}

export const RequestTakeoffProfileActionArgs = {
  encode(message: RequestTakeoffProfileActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    if (message.profileType !== 0) {
      writer.uint32(16).int32(message.profileType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestTakeoffProfileActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestTakeoffProfileActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.profileType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestTakeoffProfileActionArgs {
    return {
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
      profileType: isSet(object.profileType) ? takeoffProfileType_EnumFromJSON(object.profileType) : 0,
    };
  },

  toJSON(message: RequestTakeoffProfileActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    if (message.profileType !== 0) {
      obj.profileType = takeoffProfileType_EnumToJSON(message.profileType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestTakeoffProfileActionArgs>, I>>(base?: I): RequestTakeoffProfileActionArgs {
    return RequestTakeoffProfileActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestTakeoffProfileActionArgs>, I>>(
    object: I,
  ): RequestTakeoffProfileActionArgs {
    const message = createBaseRequestTakeoffProfileActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    message.profileType = object.profileType ?? 0;
    return message;
  },
};

function createBaseRequestTakeoffProfileResultData(): RequestTakeoffProfileResultData {
  return {};
}

export const RequestTakeoffProfileResultData = {
  encode(_: RequestTakeoffProfileResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestTakeoffProfileResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestTakeoffProfileResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RequestTakeoffProfileResultData {
    return {};
  },

  toJSON(_: RequestTakeoffProfileResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestTakeoffProfileResultData>, I>>(base?: I): RequestTakeoffProfileResultData {
    return RequestTakeoffProfileResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestTakeoffProfileResultData>, I>>(_: I): RequestTakeoffProfileResultData {
    const message = createBaseRequestTakeoffProfileResultData();
    return message;
  },
};

function createBaseRequestTakeoffProfileActionStateData(): RequestTakeoffProfileActionStateData {
  return {};
}

export const RequestTakeoffProfileActionStateData = {
  encode(_: RequestTakeoffProfileActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestTakeoffProfileActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestTakeoffProfileActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RequestTakeoffProfileActionStateData {
    return {};
  },

  toJSON(_: RequestTakeoffProfileActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestTakeoffProfileActionStateData>, I>>(
    base?: I,
  ): RequestTakeoffProfileActionStateData {
    return RequestTakeoffProfileActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestTakeoffProfileActionStateData>, I>>(
    _: I,
  ): RequestTakeoffProfileActionStateData {
    const message = createBaseRequestTakeoffProfileActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
